import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ReferenceAnchor, ReferenceAnchorFormatOptions } from '../reference-anchor';

@injectable()
export class ReferenceAnchorImpl implements ReferenceAnchor {
    format(input: string, options: ReferenceAnchorFormatOptions): string {
        const matches = input.match(new RegExp(options.matcher, 'g')) || [];
        let result = input;

        for (const matched of matches) {
            const unwrap = options.unwrap(matched);
            const index = options.generate(unwrap);
            result = result.replace(matched, options.transform(unwrap, index, matched ));
        }

        return result;
    }
}
